import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import queryString from 'query-string'
import Api from '../../api'
import Step1 from './Step1'
import Step2 from './Step2'
import FacebookStep from './FacebookStep'
import GoogleStep from './GoogleStep'
import constants from '../../constants'

class SignupWidget extends Component {
  api = new Api()
  state = {
    step: 'step1',
    firstName: "",
    lastName: "",
    email: "",
    displayName: "",
    password: "",
    passwordConfirmation: "",
    birthmonth: "",
    birthday: "",
    birthyear: "",
    city: "",
    gender: "",
    stateId: "",
    postalCode: "",
    countryId: "",
    termsAgreed: false,
    facebookToken: "",
    facebookId: "",
    fetchedParams: {},
    googleId: "",
    googleToken: "",
    affiliateId: null,
    utmSource: null,
    utmMedium: null,
    utmTerm: null,
    utmContent: null,
    utmCampaign: null,
    ageInterestedLow: null,
    ageInterestedHigh: null,
    errors: {},
    loading: false
  }

  componentDidMount() {
    const params = queryString.parse(window.location.search)
    const cookies = new Cookies()

    const affiliateId = params['affiliate_id'] || cookies.get('affiliate_id')
    const utmSource = params['utm_source'] || cookies.get('utm_source')
    const utmMedium = params['utm_medium'] || cookies.get('utm_medium')
    const utmTerm = params['utm_term'] || cookies.get('utm_term')
    const utmContent = params['utm_content'] || cookies.get('utm_content')
    const utmCampaign = params['utm_campaign'] || cookies.get('utm_campaign')
    const ageInterestedLow = params['age_interested_low']
    const ageInterestedHigh = params['age_interested_high']
    const postalCode = params['postal_code']
    const gender = params['gender']
    const promo = params['promo'] || cookies.get('promo')

      
    this.setState({affiliateId, utmSource, utmMedium, utmTerm, utmContent, utmCampaign,
      ageInterestedLow, ageInterestedHigh, postalCode, gender })

    if(promo) {
      const cookieArgs = {path: '/', domain: constants.cookieDomain}
      cookies.set("promo", promo, cookieArgs)
    }
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value })
  }

  handleStep1Submit = (e) => {
    const { firstName, lastName, email, displayName, password, passwordConfirmation, birthmonth, birthday, birthyear, gender  } = this.state
    const params = {firstName, lastName, email, displayName, password, passwordConfirmation, birthmonth, birthday, birthyear, gender }

    e.stopPropagation()
    e.preventDefault()

    this.setState({loading: true})

    this.api.validateParameters(params, () => {
      this.setState({errors: {}, step: "step2", loading: false})
    }, (errors) => {
      this.setState({errors, loading: false})
    })
  }

  handleStep2Submit = (e) => {
    const { firstName, lastName, email, displayName, password,
      passwordConfirmation, birthmonth, birthday, birthyear, gender, city,
      stateId, postalCode, countryId, termsAgreed, facebookId, facebookToken,
      googleId, googleToken, affiliateId, utmSource, utmMedium, utmTerm,
      utmContent, utmCampaign, ageInterestedLow, ageInterestedHigh } = this.state

    const talonInput = document.getElementById("talon")
    const talon = talonInput ? talonInput.value : null

    const params = { firstName, lastName, email, displayName, password, passwordConfirmation, birthmonth, birthday, birthyear, gender, city, stateId, postalCode, countryId, termsAgreed, facebookId, facebookToken, googleId, googleToken, affiliateId, utmSource, utmMedium, utmTerm, utmContent, utmCampaign, ageInterestedLow, ageInterestedHigh, talon }

    e.stopPropagation()
    e.preventDefault()

    this.setState({loading: true})

    this.api.createAccount(params, (errors) => {
      this.setState({errors, loading: false})
    })
  }

  renderStep1() {
    const { firstName, lastName, email, displayName, password, passwordConfirmation, birthmonth, birthday, birthyear, gender } = this.state
    const { loading, errors } = this.state

    return (
      <Step1
        firstName={firstName}
        lastName={lastName}
        email={email}
        displayName={displayName}
        password={password}
        passwordConfirmation={passwordConfirmation}
        gender={gender}
        birthmonth={birthmonth}
        birthday={birthday}
        birthyear={birthyear}
        loading={loading}
        errors={errors}
        onChange={this.handleChange}
        onSubmit={this.handleStep1Submit}
        onBack={() => this.setState({step: "choose_method"})}
      />
    )
  }

  renderStep2() {
    const { city, stateId, postalCode, countryId, termsAgreed } = this.state
    const { loading, errors } = this.state

    return (
      <Step2
        city={city}
        stateId={stateId}
        postalCode={postalCode}
        countryId={countryId}
        termsAgreed={termsAgreed}
        loading={loading}
        errors={errors}
        onChange={this.handleChange}
        onSubmit={this.handleStep2Submit}
        onBack={() => this.setState({step: "user_info"})}
      />
    )
  }

  renderFacebookStep() {
    const { firstName, lastName, email, displayName, birthmonth, birthday, birthyear,
      gender, city, stateId, postalCode, countryId, termsAgreed  } = this.state
    const { loading, errors, fetchedParams } = this.state

    return (
      <FacebookStep
        firstName={firstName}
        lastName={lastName}
        email={email}
        displayName={displayName}
        gender={gender}
        birthmonth={birthmonth}
        birthday={birthday}
        birthyear={birthyear}
        city={city}
        stateId={stateId}
        postalCode={postalCode}
        countryId={countryId}
        termsAgreed={termsAgreed}
        fetchedParams={fetchedParams}
        loading={loading}
        errors={errors}
        onChange={this.handleChange}
        onSubmit={this.handleStep2Submit}
        onBack={() => this.setState({step: "choose_method"})}
      />
    )

  }

  renderGoogleStep() {
    const { firstName, lastName, email, displayName, birthmonth, birthday, birthyear,
      gender, city, stateId, postalCode, countryId, termsAgreed  } = this.state
    const { loading, errors, fetchedParams } = this.state

    return (
      <GoogleStep
        firstName={firstName}
        lastName={lastName}
        email={email}
        displayName={displayName}
        gender={gender}
        birthmonth={birthmonth}
        birthday={birthday}
        birthyear={birthyear}
        city={city}
        stateId={stateId}
        postalCode={postalCode}
        countryId={countryId}
        termsAgreed={termsAgreed}
        fetchedParams={fetchedParams}
        loading={loading}
        errors={errors}
        onChange={this.handleChange}
        onSubmit={this.handleStep2Submit}
        onBack={() => this.setState({step: "choose_method"})}
      />
    )

  }

  render() {
    const { step } = this.state

    switch(step) {
      case "facebook":
        return this.renderFacebookStep()
      case "google":
        return this.renderGoogleStep()
      case "step2":
        return this.renderStep2()
      default:
        return this.renderStep1()
    }
  }
}

export default SignupWidget



// WEBPACK FOOTER //
// ./src/components/SignupWidget/index.js